import { initializeApp } from 'firebase/app';
import { getStorage, ref, uploadBytesResumable, getDownloadURL } from 'firebase/storage';
import { getFileType } from './fileHelpers';

// Firebase config
const firebaseConfig = {
  apiKey: "AIzaSyCp9rGxD4fSFtq7W8NQl74-_MFMVM-3ndk",
  authDomain: "bmassist-dashboard.firebaseapp.com",
  projectId: "bmassist-dashboard",
  storageBucket: "bmassist-dashboard.firebasestorage.app",
  messagingSenderId: "286107756538",
  appId: "1:286107756538:web:8a3f1b0e6b9c4d5e6f7g8h"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const storage = getStorage(app);

/**
 * Upload file to Firebase Storage with progress tracking
 * @param {File} file - The file to upload
 * @param {Function} onProgress - Callback for upload progress (0-100)
 * @returns {Promise<Object>} Attachment object with metadata
 */
export const uploadFileToFirebase = (file, onProgress) => {
  return new Promise((resolve, reject) => {
    const fileType = getFileType(file.type);
    const timestamp = Date.now();
    const randomId = Math.random().toString(36).substring(7);
    const storagePath = `messages/${fileType}s/${timestamp}_${randomId}_${file.name}`;
    
    const storageRef = ref(storage, storagePath);
    const uploadTask = uploadBytesResumable(storageRef, file);
    
    uploadTask.on(
      'state_changed',
      (snapshot) => {
        // Progress tracking
        const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        if (onProgress) {
          onProgress(Math.round(progress));
        }
      },
      (error) => {
        // Error handling
        console.error('Upload error:', error);
        reject(error);
      },
      async () => {
        // Success - get download URL
        try {
          const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
          
          const attachment = {
            id: randomId,
            file_name: file.name,
            mime_type: file.type,
            file_type: fileType,
            size_bytes: file.size,
            storage_provider: 'firebase',
            storage_key: storagePath,
            file_url: downloadURL,
            uploaded_at: new Date().toISOString()
          };
          
          resolve(attachment);
        } catch (error) {
          reject(error);
        }
      }
    );
  });
};

/**
 * Upload multiple files with progress tracking
 * @param {File[]} files - Array of files to upload
 * @param {Function} onProgress - Callback for overall progress (0-100)
 * @returns {Promise<Object[]>} Array of attachment objects
 */
export const uploadMultipleFiles = async (files, onProgress) => {
  const totalFiles = files.length;
  let completed = 0;
  
  const uploadPromises = files.map((file) => {
    return uploadFileToFirebase(file, (fileProgress) => {
      // Track individual file progress
      // Update overall progress when file completes
      if (fileProgress === 100) {
        completed++;
        const overallProgress = Math.round((completed / totalFiles) * 100);
        if (onProgress) {
          onProgress(overallProgress);
        }
      }
    });
  });
  
  return Promise.all(uploadPromises);
};
